<div id="login-component" class="component-inner-wrapper login-component-class">
  <main
    class="main-content"
    style="
      background: #fff url('Logo_min.png') no-repeat bottom center;
      background-size: contain;
    "
  >
    <div class="container">
      <div class="login_wrapper">
        <div class="login-container">
          <div class="logo-placeholder">
            <img src="mc_logo.png" alt="Montage Connect" />
          </div>

          <form
            class="login-form"
            [formGroup]="loginForm"
            (ngSubmit)="onLogin()"
            novalidate
          >
            <div class="form-group">
              <label for="email">
                Email Address<span class="required">*</span>
              </label>
              <input
                type="email"
                id="email"
                formControlName="email"
                class="form-control"
                placeholder="Enter email address"
                autocomplete="username"
              />
              <small
                class="form-error"
                *ngIf="
                  loginForm.get('email')?.touched &&
                  loginForm.get('email')?.hasError('required')
                "
              >
                Email Address is required.
              </small>
              <small
                class="form-error"
                *ngIf="
                  loginForm.get('email')?.touched &&
                  loginForm.get('email')?.hasError('email')
                "
              >
                Enter a valid email address.
              </small>
            </div>

            <div class="form-group">
              <label for="password">
                Password<span class="required">*</span>
              </label>
              <input
                type="password"
                id="password"
                formControlName="password"
                class="form-control"
                placeholder="Enter password"
                autocomplete="current-password"
              />
              <small
                class="form-error"
                *ngIf="
                  loginForm.get('password')?.touched &&
                  loginForm.get('password')?.hasError('required')
                "
              >
                Password is required.
              </small>
            </div>

            <div class="button-container">
              <button
                type="button"
                class="btn-cancel"
                (click)="onCancel()"
                [disabled]="isSubmitting"
              >
                Cancel
              </button>
              <button
                type="submit"
                class="btn-confirm"
                [disabled]="isSubmitting"
              >
                {{ isSubmitting ? 'Logging in...' : 'Login' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</div>
